module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAOCAYAAABDwm71AAAAgElEQVRIic3TwQ1AUBCE4SGuTztq0Y+SqAAVKeB3QCLylpPMm2Szh718h1kBMk0HjEDK3V0oARNH5hzOCUvAEuGcsFecGxbi3KgcbgFSBaACU7sBUWpJVQHTSlpP0yqpdXfr6td871cJ5c+i3LAQ5YaNEQpQ89tbfWc4dy9pex53TW+PxrVQXHMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right-big-icon.png
// module id = Mo2Z
// module chunks = 1